import { render } from "./Create25Liquidation2.vue?vue&type=template&id=1c98d854"
import script from "./Create25Liquidation2.vue?vue&type=script&lang=js"
export * from "./Create25Liquidation2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__